import { render, staticRenderFns } from "./ExaminationRoom.vue?vue&type=template&id=bb166076&"
import script from "./ExaminationRoom.vue?vue&type=script&lang=js&"
export * from "./ExaminationRoom.vue?vue&type=script&lang=js&"
import style0 from "./ExaminationRoom.vue?vue&type=style&index=0&id=bb166076&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports